import React from "react";

const Footer = () => {
  return (
    <div className="flex justify-center items-center h-14 pb-5 bg-black bg-gradient-to-b from-gray-800 to-black text-white">
      <p>Made with ❤️ by Rishav Uppal</p>
    </div>
  );
};

export default Footer;
